export const blockIconsTextformattingContentCopyNew = (
	<span className='material-symbols-outlined'>content_copy</span>
);
